import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd/lib/date-picker/generatePicker';
var DatePicker = generatePicker(dayjsGenerateConfig);
export default DatePicker;